import PropTypes from 'prop-types';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton } from '@mui/material';

const MoreActionsButton = (props) => {
  const { onClick } = props;
  return (
    <IconButton
      className="more-actions-button"
      onClick={onClick}
      size="small"
      sx={{ margin: '-1rem' }}
    >
      <MoreHorizIcon />
    </IconButton>
  );
};

MoreActionsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default MoreActionsButton;
